import * as React from 'react';
import moment from 'moment';
import 'moment/locale/es-us';
import 'moment/locale/pt-br';
import { ThemeProvider } from '@mui/material/styles';
import { ELocale } from '@lumahealthhq/ui-model-types';
import { useCurrentLocale } from '@lumahealthhq/ui-utils';
import createTheme from '../styles/createTheme';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UICoreProvider({
  children,
  themeOptions
}) {
  const theme = React.useMemo(() => themeOptions && createTheme(themeOptions), [themeOptions]);
  const locale = useCurrentLocale();
  React.useEffect(() => {
    moment.locale(locale || ELocale.EnglishUS);
  }, [locale]);
  React.useEffect(() => {
    // Expose the theme as a global variable so people can play with it.
    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.theme = theme;
    }
  }, [theme]);
  return theme ? /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: children
  }) : children;
}